module.exports = __webpack_public_path__ + "53257f79048da8d32be3bfe670c50767.png";